import React from "react";
import { imageHost } from "@wss/image";
import VideoThumbnail from "~/common/MediaViewerV2/SharedComponents/VideoViewer/VideoThumbnail/VideoThumbnail";
import { Image, ModelFiles, Video } from "~/common/MediaViewerV2/model";

interface VideoGalleryRendererProps {
  index: number;
  media: (Image | Video | ModelFiles)[];
  video: Video;
  handleThumbnailClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    index: number,
  ) => void;
  borderStyling: string;
}

const VideoGalleryRenderer = ({
  index,
  media,
  video,
  handleThumbnailClick,
  borderStyling,
}: VideoGalleryRendererProps) => (
  <a
    aria-label={`gallery item ${index + 1} of ${media.length}, video`}
    role="button"
    href={`#slide-${index}`}
    key={`vid-${index}`}
    data-testid="video-dot"
    {...(video.id ? { "data-video-id": video.id } : {})}
    onClick={(e) => {
      handleThumbnailClick(e, index);
    }}
    className={`
      ${borderStyling}
      box-border
      p-1-1/2
      w-full
      h-full
      relative
      inline-block
      before:content-['']
      before:absolute
      before:inset-0
      before:border-solid
      before:rounded
      [@media(hover:hover)]:hover:before:border-2
      [@media(hover:hover)]:hover:before:border-gray-700
      focus:outline focus:outline-3
      focus:outline-offset-[-3px]
      focus:outline-transparent
      focus-visible:before:border-[3px]
      focus-visible:before:border-[#005FCC]
    `}
  >
    <VideoThumbnail
      tooltipText={video.title ?? ""}
      image={`${imageHost}${video.thumbnailImage}`}
    />
  </a>
);

export default VideoGalleryRenderer;
